<template>
  <div class="container">
    <div class="btn">
      <a-button type="primary" @click="toCreate">新增规则</a-button>
      <a-button type="primary" @click="toTest">测试</a-button>

    </div>
    <commonTable :columns="columns" :data-source="list" :loading="loading">
      <template slot="name" slot-scope="text">{{ text }}</template>
      <span slot="action" slot-scope="text, record">
        <a @click="toDetail(record)">详情</a>
        <a-divider type="vertical" />
        <a @click="toFix(record)">修改</a>
        <a-divider type="vertical" />
        <a-popconfirm title="确定要删除该条规则吗？" ok-text="确定" cancel-text="取消" @confirm="delItem(record)">
          <a @click="toDel(record)"> 删除</a>
        </a-popconfirm>
      </span>
    </commonTable>
    <common-pagination
        :total="total"
        :page="searchOptions.page"
        @pageChange="pageChange"
        @pageSizeChange="pageSizeChange"
    ></common-pagination>
  </div>
</template>
<script>
import commonTable from "@/components/commonTable";
import commonPagination from "@/components/commonPagination";
const columns = [
  {
    title: '规则名称',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '新增时间',
    dataIndex: 'createTime',
    key: 'createTime',
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];
import {ruleDel,ruleList} from "@/api/rule";
export default {
  components:{commonTable,commonPagination},
  data() {
    return {
      userId:'',
      columns,
      list:[],
      loading:false,
      total: 0,
      searchOptions: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    window.addEventListener("message", this.onmessage);
    this.getUserId()
  },
  beforeDestroy() {
    window.removeEventListener("message", this.onmessage);
  },
  methods:{
    onmessage(event) {
      console.log(event, 'event');
      if (event.data.action === "userId") {
        this.userId = event.data.value;
        sessionStorage.setItem('userId',event.data.value)
        console.log(this.userId,123);
        this.getList()
      }
    },
    getUserId() {
      window.parent.postMessage({action: "getUserId"}, "*");
    },
    delItem(e){
      console.log(e);
      this.$message.success('删除成功')
      this.getList()
    },
    toTest(){
      this.$router.push({name:'test'})
    },
    toCreate(){
      this.$router.push({name:'CreateRule',query:{type:'create'}})
    },
    toDetail(e){
      console.log(e);
      this.$router.push({name:'CreateRule',query:{id:e.id,type:'look'}})
    },
    toFix(e){
      console.log(e);
      this.$router.push({name:'CreateRule',query:{id:e.id,type:'change'}})
    },
    toDel(e){
      console.log(e);

    },
    async getList(
        params = {
          pageNum: 1,
          pageSize: 10,
        }){
      console.log(321);
      this.loading = true;
      const data = await ruleList(params)
      console.log(data,'data');
      params.pageNum = params.page;
      this.list = [
        {
          name:'A厂命名规则',
          createTime:'2022-05-20 16:44:15',
          id:1
        },
        {
          name:'B厂命名规则',
          createTime:'2022-05-20 16:44:15',
          id:2
        },
      ]
      this.total = 2
      this.loading = false;
      // getBusinessList(params).then((res) => {
      //   if (res.code == 200) {
      //     this.loading = false;
      //     let index = 1;
      //     this.total = res.data.total;
      //     this.data = res.data.list.map((item) => {
      //       item.index =
      //           (this.searchOptions.page - 1) * this.searchOptions.pageSize +
      //           index;
      //       item.imgs = item.imgs == "" ? [] : item.imgs.split(",");
      //       index++;
      //       return item;
      //     });
      //   }
      // });

    },
    pageChange(pageNum, pageSize) {
      this.searchOptions.pageNum = pageNum;
      this.getList(this.searchOptions);
    },
    pageSizeChange(page, pageSize) {
      this.searchOptions.pageNum = 1;
      this.searchOptions.pageSize = pageSize;
      this.getList(this.searchOptions);
    },
  }
};
</script>
<style lang="scss" scoped>
.container{
  width: 100%;
  padding: 20px;
  .btn{
    text-align: left;
    margin-bottom: 20px;
  }
}

</style>
